import { render, staticRenderFns } from "./LaudoCarbonoModal.vue?vue&type=template&id=20a81f60&scoped=true&lang=pug"
import script from "./LaudoCarbonoModal.vue?vue&type=script&lang=js"
export * from "./LaudoCarbonoModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoCarbonoModal.vue?vue&type=style&index=0&id=20a81f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a81f60",
  null
  
)

export default component.exports